import React from "react"
import Img from "gatsby-image/withIEPolyfill"

import { Eyebrow, CTA, Headline } from "@shared"
import { css, logTool } from "@jsUtils"

import Styles from "./storyblock.module.scss"

const log = logTool()

/**
 * Render a story/article chunk of content, usually on list pages where it's summarizes articles etc.
 * @param {object} props - react props
 * @param {string} props.readMore - Text for the link
 * @param {string} props.color - string color from page / themes
 * @param {object} props.story - article content object
 * @param {string} props.filter - filter string
 * @param {boolean} props.hasCategory - boolean to hide/show the category line
 * @param {boolean} props.hasCopy - boolean to hide/show the body copy
 * @param {boolean} props.hideDate - boolean to hide/show the date
 * @param {object} props.importedStyle - style object from module that uses this component
 */
const StoryBlock = ({
  linkText = "Read More",
  color,
  story,
  filter = "story",
  hasCategory,
  hasCopy,
  hideDate,
  importedStyle,
  ready
}) => {
  log("StoryBlock", { linkText, color, story, filter, hasCategory, hasCopy, importedStyle, ready })
  return (
    <div className={css(Styles.storyWrapper, importedStyle.wrapper)} key={`${filter}-${story.id}`}>
      {hasCategory && (
        <Eyebrow className={css(Styles.eyebrow, importedStyle.eyebrow)} color={color}>
          {story.category}
        </Eyebrow>
      )}
      <Img
        className={css(Styles.storyImage, importedStyle.image)}
        alt={story.thumbnail?.title}
        fluid={story.thumbnail?.fluid}
      />
      {!hideDate && (
        <Headline className={css(Styles.storyDate, importedStyle.date)} size={6}>
          {story.date}
        </Headline>
      )}
      <Headline className={css(Styles.storyTitle, importedStyle.title)} size={5}>
        {story.title}
      </Headline>
      {hasCopy && <p className={css(Styles.storyCopy, importedStyle.copy)}>{story.copy}</p>}
      {story.author && <p className={Styles.storyAuthor}>{story.author}</p>}
      <CTA
        ascope="CTAS"
        adata="NEWS.READMORE"
        ready={ready}
        className={css(Styles.storyCta, importedStyle.cta)}
        color={color}
        to={story.slug}
      >
        {linkText}
      </CTA>
    </div>
  )
}

export default StoryBlock
